<template>
  <div class="page-wrapper">
    <banner />
    <div class="page-container">
      <!-- 左侧内容区 -->
      <div class="content-left">
        <!-- 顶部导航筛选 -->
        <nav-filter />
        <!-- 教师基本信息 -->
        <div class="teacher-info">
          <div class="teacher-avatar">
            <img :src="picUrl + teacherInfo.pic1" :alt="teacherInfo.schoolname">
          </div>
          <div class="info-content">
            <div class="name-location">
              <span class="teacher-name">{{teacherInfo.schoolname}}</span>
              <span class="location"><img src="@/assets/images/position.png" alt="位置" class="pos-icon">{{teacherInfo.address}}</span>
            </div>
            <div class="info-container">
              <div class="info-grid">
                <div class="info-item">
                  <span class="label">班期：</span>
                  <el-tooltip :content="teacherInfo.banqi" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.banqi}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">办学形式：</span>
                  <el-tooltip :content="teacherInfo.xingshi" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.xingshi}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">类别：</span>
                  <el-tooltip :content="teacherInfo.leibie" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.leibie}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">联系人：</span>
                  <el-tooltip :content="teacherInfo.lianxiren" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.lianxiren}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">在校生：</span>
                  <el-tooltip :content="String(teacherInfo.studentcount)" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.studentcount}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">成立时间：</span>
                  <el-tooltip :content="teacherInfo.cldate" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.cldate}}年</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">电话：</span>
                  <el-tooltip :content="teacherInfo.tel" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.tel}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">网址：</span>
                  <el-tooltip :content="teacherInfo.website" placement="bottom-start" :show-after="200">
                    <span class="value web-url">{{teacherInfo.website}}</span>
                  </el-tooltip>
                  <el-button
                    type="text"
                    class="copy-btn"
                    @click="copyWebsite"
                    v-if="teacherInfo.website">
                    <img src="@/assets/images/fuzhi.png" alt="复制" class="copy-icon">
                  </el-button>
                </div>
              </div>
              <div class="stats">
                <div class="stat-item">
                  <img src="@/assets/images/eye.png" alt="浏览" class="stat-icon">
                  <span class="stat-label">浏览</span>
                  <span class="stat-value">{{teacherInfo.clickcount}}</span>
                </div>
                <div class="stat-item" @click="handleShare">
                  <img src="@/assets/images/share.png" alt="分享" class="stat-icon">
                  <span class="stat-label">分享</span>
                  <span class="stat-value">{{teacherInfo.sharecount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 操作按钮组 -->
        <div class="action-buttons">
          <el-popover
            placement="bottom"
            trigger="click"
            popper-class="certificate-popover"
            width="auto"
          >
            <template #reference>
              <div class="button-item">
                <img src="@/assets/images/certificate.png" alt="查看证书">
                <span>查看证书</span>
              </div>
            </template>
            <div class="certificate-content">
              <template v-if="teacherInfo.zhengshu">
                <img :src="picUrl + teacherInfo.zhengshu" alt="资质证书" class="certificate-img">
              </template>
              <div v-else class="empty-state">
                <img src="@/assets/images/empty.png" alt="暂无证书" class="empty-icon">
                <p class="empty-text">暂无证书信息</p>
              </div>
            </div>
          </el-popover>
          <el-popover
            placement="bottom"
            trigger="click"
            popper-class="certificate-popover"
            width="auto"
          >
            <template #reference>
              <div class="button-item">
                <img src="@/assets/images/certificate.png" alt="批文">
                <span>批文</span>
              </div>
            </template>
            <div class="certificate-content">
              <template v-if="teacherInfo.piwen">
                <img :src="picUrl + teacherInfo.piwen" alt="批文" class="certificate-img">
              </template>
              <div v-else class="empty-state">
                <img src="@/assets/images/empty.png" alt="暂无批文" class="empty-icon">
                <p class="empty-text">暂无批文信息</p>
              </div>
            </div>
          </el-popover>
        </div>

        <!-- 学校简介 -->
        <div class="info-section resume-section">
          <div class="section-header">
            <img src="@/assets/images/resume.png" alt="学校简介" class="header-icon">
            <span class="header-text">学校简介</span>
          </div>
          <div class="section-content">
            {{teacherInfo.jianjie}}
          </div>
        </div>

        <!-- 课程内容 -->
        <div class="info-section course-section">
          <div class="section-header">
            <img src="@/assets/images/kcnr.png" alt="课程内容" class="header-icon">
            <span class="header-text">课程内容</span>
          </div>
          <div class="section-content">
            {{teacherInfo.kecheng}}
          </div>
        </div>

        <!-- 组织机构 -->
        <div class="text-materials-section">
          <div class="section-header">
            <div class="header-left">
              <div class="title-area">
                <img src="@/assets/images/book.png" alt="组织机构" class="header-icon">
                <span class="header-text">组织机构</span>
              </div>
            </div>
          </div>
          <div class="section-content">
          </div>
        </div>

        <!-- 信息公告 -->
        <div class="free-videos-section">
          <div class="section-header">
            <div class="header-left">
              <div class="title-area">
                <img src="@/assets/images/video.png" alt="信息公告" class="header-icon">
                <span class="header-text">信息公告</span>
              </div>
            </div>
            <span class="more" @click="toGonggaoList">更多 ></span>
          </div>
          <div class="section-content">
            <div class="gonggao-list">
              <div class="gonggao-item" v-for="item in gonggaoInfo" :key="item.id" @click="toGonggaoDeatil(item.id)">
                <div class="gonggao-item-top">
                  <div class="gonggao-item-title">{{item.title}}</div>
                  <div class="gonggao-item-time">发布时间：{{item.inputtime}}</div>
                </div>
                <div class="gonggao-item-content">{{item.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧广告区 -->
      <!-- <ad-sidebar /> -->
      <v-right :marketBannerSmall="marketBannerSmall" :marTop="false"></v-right>
    </div>
    <!-- 分享弹窗组件 -->
    <share-dialog
      :visible="showShareDialog"
      :share-data="shareDialogData"
      @close="handleShareClose"
      @share-success="handleShareSuccess"
    />
  </div>
</template>

<script>
import Banner from '@/components/common/Banner'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter'
import ShareDialog from '@/components/common/ShareDialog.vue'
import { getEduDetails, getLastFCGGXX } from '@/axios/education'
import url from '@/axios/url'
import sign from '@/auth/sign'

export default {
  name: 'TeacherDetail',
  components: {
    Banner,
    // AdSidebar,
    vRight,
    ShareDialog,
    NavFilter
  },
  data () {
    return {
      picUrl: url.picUrl,
      appid: 'wzwebapp',
      timestamp: parseInt(new Date().getTime() / 1000),
      id: parseInt(this.$route.query.id),
      type: parseInt(this.$route.query.type),
      teacherInfo: {
        name: '',
        position: '',
        political: '',
        school: '',
        rating: '',
        jobStatus: '',
        yearsOfTeaching: '',
        location: '',
        tel: '',
        website: '',
        views: '0',
        shares: '0',
        zhici: '',
        jianli: '',
        zhaopian: '',
        wenping: '',
        zhengjian: ''
      },
      gonggaoInfo: [],
      showShareDialog: false
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    },
    // 分享弹窗数据
    shareDialogData () {
      return {
        title: this.teacherInfo.schoolname || '',
        teacherName: this.teacherInfo.schoolname || '',
        teacherId: this.id || null,
        coverImage: this.teacherInfo.pic1 || '',
        picUrl: this.picUrl,
        type: this.type,
        appid: this.appid,
        url: window.location.href
      }
    }
  },
  created () {
    this.getTeacherDetails()
    this.lastFCGGXX()
  },
  methods: {
    handleShare () {
      this.showShareDialog = true
    },
    handleShareClose () {
      this.showShareDialog = false
    },
    // 分享成功回调
    handleShareSuccess () {
      this.getTeacherDetails()
    },
    getTeacherDetails () {
      const params = {
        appid: this.appid,
        timestamp: this.timestamp,
        id: this.id,
        type: this.type
      }
      const signO = sign(params)
      params.sign = signO

      getEduDetails(params).then(res => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data
          this.teacherInfo = data
        }
      })
    },
    // 获取5条最新的学校风采、校园公告、校园信息
    lastFCGGXX () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        stype: '2',
        ntype: '2'
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      getLastFCGGXX(oneParams).then(res => {
        if (res.data.msg === '请求成功') {
          this.gonggaoInfo = res.data.data
        }
      })
    },
    toGonggaoList () {
      this.$router.push({
        name: 'NoticeList',
        query: { id: this.id }
      })
    },
    toGonggaoDeatil (id) {
      this.$router.push({
        name: 'NoticeDetail',
        query: {
          id,
          type: 2
        }
      })
    },
    copyWebsite () {
      if (this.teacherInfo.website) {
        navigator.clipboard.writeText(this.teacherInfo.website).then(() => {
          this.$message.success('复制成功')
        }).catch(() => {
          this.$message.error('复制失败')
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-wrapper {
  background: #f8f8f8;
  min-height: 100vh;
  padding: 0 0 20px;

  .page-container {
    width: 1200px;
    margin: 20px auto 0;
    display: flex;
    gap: 14px;

    .content-left {
      flex: 1;
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0 1px 4px rgba(0,0,0,.05);
      padding: 20px;
      max-width: 810px;

      .teacher-info {
        background: transparent;
        box-shadow: none;
        padding: 0;
        display: flex;
        gap: 20px;
        margin-bottom: 20px;

        .teacher-avatar {
          width: 144px;
          height: 144px;
          border-radius: 6px;
          overflow: hidden;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .info-content {
          flex: 1;

          .name-location {
            display: flex;
            align-items: center;
            margin-bottom: 12px;

            .teacher-name {
              font-size: 16px;
              color: #EF8432;
              font-weight: bold;
              margin-right: 50px;
            }

            .location {
              font-size: 13px;
              color: #666666;
            }

            .pos-icon {
              width: 14px;
              margin-right: 6px;
            }
          }

          .info-container {
            background: transparent;
            padding: 0;

            .info-grid {
              margin-bottom: 16px;
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 10px;

              .info-item {
                display: flex;
                align-items: center;
                .web-url {
                  color: #0D52F8 !important;
                }
                .label {
                  color: #AF8338;
                  font-size: 13px;
                  margin-right: 8px;
                  white-space: nowrap;
                }

                .value {
                  color: #333333;
                  font-size: 13px;
                  max-width: 120px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .copy-btn {
                  padding: 2px 4px;
                  margin-left: 4px;

                  .copy-icon {
                    width: 14px;
                    height: 14px;
                  }

                  &:hover {
                    background-color: #f5f5f5;
                  }
                }
              }
            }

            .stats {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 10px;
              margin-top: 16px;

              .stat-item {
                display: flex;
                width: 50%;
                align-items: center;
                cursor: pointer;

                .stat-icon {
                  width: 16px;
                  height: 16px;
                  margin-right: 4px;
                }

                .stat-value {
                  color: #EF8432;
                  font-size: 13px;
                }

                .stat-label {
                  color: #3D3D3D;
                  font-size: 13px;
                  margin-right: 4px;
                }
              }
            }
          }
        }
      }

      .action-buttons {
        display: flex;
        gap: 24px;
        margin-bottom: 20px;
        padding: 0;
        background: transparent;
        box-shadow: none;
        align-items: center;
        justify-content: center;

        .button-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          height: 50px;
          min-width: 182px;
          background: #ffffff;
          cursor: pointer;
          transition: all 0.3s;
          border: 1px solid #F0F0F0;
          border-radius: 11px;

          img {
            width: 38px;
            height: 38px;
          }

          span {
            font-size: 14px;
            color: #333333;
            font-weight: bold;
          }

          &:hover {
            background: #F8F8F8;
          }
        }
      }
    }
  }
}

.info-section {
  background: #FFFFFF;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 16px;
  border: 1px solid #F0F0F0;

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .header-icon {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }

    .header-text {
      font-size: 16px;
      color: #3DB963;
      font-weight: 500;
    }
  }

  .section-content {
    color: #666666;
    font-size: 14px;
    line-height: 1.6;
  }

  &.resume-section {
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 110px;
      height: 33px;
      background: #3DB963;
      border-radius: 0 0 16px 0;
      z-index: 0;
    }

    .section-header {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      height: 33px;
      display: flex;
      align-items: center;
      padding-left: 16px;

      .header-icon {
        width: 18px;
        height: 18px;
        margin-right: 2px;
      }

      .header-text {
        color: #ffffff;
        font-size: 14px;
        font-weight: normal;
      }
    }

    .section-content {
      position: relative;
      z-index: 1;
      color: #666666;
      font-size: 14px;
      line-height: 1.8;
      padding: 40px 16px 16px;
    }
  }

  &.course-section {
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 110px;
      height: 33px;
      background: #EF8432;
      border-radius: 0 0 16px 0;
      z-index: 0;
    }
    .section-header {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      height: 33px;
      display: flex;
      align-items: center;
      padding-left: 16px;

      .header-icon {
        width: 18px;
        height: 18px;
        margin-right: 2px;
      }

      .header-text {
        color: #ffffff;
        font-size: 14px;
        font-weight: normal;
      }
    }
    .section-content {
      position: relative;
      z-index: 1;
      color: #666666;
      font-size: 14px;
      line-height: 1.8;
      padding: 40px 16px 16px;
    }
  }
}

.text-materials-section {
  position: relative;
  overflow: hidden;
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 8px;
  margin-bottom: 16px;

  .section-header {
    position: relative;
    z-index: 1;
    height: 33px;
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      height: 100%;
      border-radius: 0 0 8px 0;
      font-size: 13px;

      .title-area {
        display: flex;
        align-items: center;
        background: #3499E1;
        height: 100%;
        padding: 0 20px;
        border-radius: 0 0 16px 0;

        .header-icon {
          width: 18px;
          height: 18px;
          margin-right: 2px;
        }

        .header-text {
          color: #FFFFFF;
          font-size: 14px;
          font-weight: normal;
        }
      }
    }
  }
  .section-content {
      z-index: 1;
      color: #666666;
      font-size: 14px;
      line-height: 1.8;
      padding: 40px 16px 16px;
    }
}

.free-videos-section {
  position: relative;
  overflow: hidden;
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 8px;
  margin-bottom: 16px;

  .section-header {
    position: relative;
    z-index: 1;
    height: 33px;
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      height: 100%;
      border-radius: 0 0 8px 0;
      font-size: 13px;

      .title-area {
        display: flex;
        align-items: center;
        background: #3FBABE;
        height: 100%;
        padding: 0 20px;
        border-radius: 0 0 16px 0;

        .header-icon {
          width: 18px;
          height: 18px;
          margin-right: 2px;
        }

        .header-text {
          color: #FFFFFF;
          font-size: 14px;
          font-weight: normal;
        }
      }
    }

    .more {
      padding: 0 16px;
      color: #666666;
      font-size: 14px;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }

  .section-content {
    padding: 16px;

    .gonggao-list {
      .gonggao-item {
        padding: 16px;
        border-bottom: 1px solid #F0F0F0;
        cursor: pointer;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background: #F8F8F8;
          .gonggao-item-title {
            color: #3FBABE;
          }
        }

        .gonggao-item-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2px;

          .gonggao-item-title {
            font-size: 16px;
            color: #333333;
            font-weight: 500;
            transition: color 0.3s;
          }

          .gonggao-item-time {
            font-size: 14px;
            color: #999999;
          }
        }

        .gonggao-item-content {
          font-size: 14px;
          color: #666666;
          line-height: 1.6;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}

.certificate-popover {
  padding: 0;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  .certificate-content {
    width: 400px;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    .certificate-img {
      width: 400px;
      height: auto;
      display: block;
      border-radius: 8px;
    }

    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px 0;

      .empty-icon {
        width: 150px;
        height: 150px;
        margin-bottom: 16px;
      }

      .empty-text {
        font-size: 14px;
        color: #999;
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/organizationDetail.vue